import { useExperiment } from '@hungryroot/experiments';
import { ROUTE_QUIZ_GOALS_BENEFITS } from '@hungryroot/routes';
import { tags } from '@hungryroot/tags';
import { type Quiz } from '../defs/quiz';
import {
  ROUTE_FOOD_PREFERENCES_INTRO,
  ROUTE_MACRO_NUTRIENT_LOW_SODIUM,
  ROUTE_MEAT,
  ROUTE_QUIZ_BUDGET_BENEFITS,
  ROUTE_SEAFOOD,
  ROUTE_SEQUENCES,
  type AllQuizRoutes,
} from '../defs/routes';
import {
  skipQuizRoutes,
  shouldExcludeMeatRoute,
  shouldExcludeSeafoodRoute,
} from '../navigation/navigation';

/**
 *
 * "useQuizRoutes" is responsible to returning the real-time
 * routes available to the user.
 *
 * This hook takes into account the user's quiz data, experiment enrollments
 * and any other data needed to construct the user's real time quiz routes.
 *
 */
export function useQuizRoutes(quiz?: Quiz): AllQuizRoutes[] | undefined {
  const dietDrivenPreferencesVariant = useExperiment(175);

  if (quiz === undefined || dietDrivenPreferencesVariant === undefined) {
    return undefined;
  }

  const quizRoutes = ROUTE_SEQUENCES.base;

  // Remove skipped routes based on experiment enrollment or user input
  const routes = skipQuizRoutes(quizRoutes, {
    [ROUTE_MEAT]: shouldExcludeMeatRoute(quiz.habits),
    [ROUTE_SEAFOOD]: shouldExcludeSeafoodRoute(quiz.habits),
    [ROUTE_QUIZ_BUDGET_BENEFITS]:
      quiz.budget === null || quiz.budget === undefined,
    [ROUTE_QUIZ_GOALS_BENEFITS]:
      quiz.goals === null || quiz.goals?.length === 0,
    [ROUTE_MACRO_NUTRIENT_LOW_SODIUM]: !quiz.macroNutrient?.includes(
      tags.LowSodium
    ),
    [ROUTE_FOOD_PREFERENCES_INTRO]: dietDrivenPreferencesVariant < 1,
  });

  return routes;
}
